import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { EventTypes } from '@cashier-integration/model';

import { setPaymentFormStatus } from '@cashier/cashier-data-access';
import { FormStatuses } from '@cashier/cashier-model';
import { eventBus } from '@cashier/cashier-shared';

export const useSubmittingByEvent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return eventBus.on(EventTypes.ON_PAYMENT_DATA_SUBMITTED, () => {
      dispatch(setPaymentFormStatus(FormStatuses.SUBMITTED));
    });
  }, [dispatch]);

  useEffect(() => {
    return eventBus.on(EventTypes.ON_PAYMENT_DATA_SUBMIT_DECLINED, () => {
      dispatch(setPaymentFormStatus(FormStatuses.READY));
    });
  }, [dispatch]);
};
